import React from 'react'

function Signposting() {
  return (
    <div id='signposting'>
      <h2 id='sign-tagline'>Living with sight loss is hard!</h2>
      <p className='sign-content'>Help is available for those who need it, unfortunately no one ever tells you how to access them.</p>
      <p className='sign-content'>The people best suited to provide you with the support you require can vary depending on the type and severity of visual impairments, age, location or even just preferences.</p>
      <p className='sign-content'>Please contact us and we will endeavour to connect you with the appropriate local and national organisations who can equip you with the best tools necessary for your sight loss journey</p>
      <h3>Our Vision Loss Hub has an open session at the Alice Wheeldon Room, Derby Council House, on the last Tuesday of every month.</h3>
      <p>While we would endeavour to meet you on a drop in basis things may get crowded depending on how busy it gets so please message your interest ahead of time to avoid disappointment</p>
    </div>
  )
}

export default Signposting